import { get } from 'lodash'

// - const loadingPageHost = get(process.env, 'LOADING_PAGE_HOST')

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório médico',
  'emergency_room': 'Emergência',
  laboratory: 'Labotarório',
  others: 'Outros'
}

/** tratando se for develop */
const getHost = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return window.location.host.replace(':8080', '')
  } else {
    return window.location.host
  }
}

const parseType = (type) => {
  return get(types, type, 'Outros')
}

const prepareShow = professionalProfilePublic => {
  professionalProfilePublic.company_type = parseType(professionalProfilePublic.agenda.address.company)

  return professionalProfilePublic
}

export default {
  async checkDomainOperator () {
    const host = {
      domain: getHost()
    }
    await this.$http.post('v1/scheduling/see/operator/domain', host)
      .then(({data}) => {
        /** Removendo valores anteriores */
        const operatorCovenantSession = localStorage.getItem('operador-covenant')
        if (operatorCovenantSession !== null) {
          localStorage.removeItem('operador-covenant')
        }

        /** setando dominio da operadora */
        localStorage.setItem('operador-domain', getHost())

        /** se tem resultado  */
        if (data.length >= 1) {
          /** retornando das do profissional */
          localStorage.setItem('operador-covenant', data[0].name)
        }
        this.getCompanyProfessionalSchedules()
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  async getCompanyProfessionalSchedules () {
    this.loading = true
    await this.$http.get('/v1/scheduling/see/cnpj/' + this.cnpj + '/crm/' + this.crm + '/uf/' + this.uf)
      .then(({data}) => {
        this.professionalProfilePublic = data
        if (typeof this.professionalProfilePublic === 'object') {
          if (this.professionalProfilePublic.length <= 0) {
            // visualizando msg professional nao tem perfila ainda
            this.noProfilePublic = true
            this.loading = false
            this.loadingTwo = false
          } else {
            this.operatorCovenant = localStorage.getItem('operador-covenant')
            /** Total de agendamentos para agenda */
            this.totalAgendas = data.length
            /** Total de agendamento para company */
            this.totalAgendaSchedules = this.professionalProfilePublic.reduce((acc, item) => {
              return acc + item.total_agendas
            }, 0)

            /** Array para retorno do novo array  */
            let reduced = []

            /** Retornando quantidade de professionais pelo crm  */
            data.forEach((item) => {
              var duplicated = reduced.findIndex(ri => {
                return item.document === ri.document
              }) > -1

              if (!duplicated) {
                reduced.push(item)
              }
            })

            this.totalProfessional = reduced.length
            this.loading = false
          }
        }
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  openExternalLink: function (url) {
    if (url === null || url === 'undefined') {
      return
    }
    window.open(url, '_blank')
  },
  prepareShow,
  typeClinic: function (type) {
    const clinicType = parseType(type)
    return clinicType
  },
  priceReal (price) {
    const real = price.split('.')
    return real[0]
  },
  priceCents (price) {
    const real = price.split('.')
    return real[1]
  },
  isAvatar (avatar) {
    const a = avatar.split('/')
    return a[5]
  },
  open () {
    this.openerText = 'Close'
    this.isOpen = true
  },
  close () {
    this.openerText = 'Open'
    this.isOpen = false
  },
  toggle () {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/gadget/resources/methods.js